// extracted by mini-css-extract-plugin
export default {"root":"SidebarSubMenu_root__IfScf"};